import React from 'react';
import { FiRefreshCw } from 'react-icons/fi';

const SearchHeader = ({ onRefreshLocation, isLocating }) => {
  return (
    <header className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
      <div>
        <h1 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-amber-400 to-yellow-500 bg-clip-text text-transparent">
          Trouver un Déménageur
        </h1>
        <p className="text-gray-400 mt-1">
          Recherchez et comparez les professionnels près de chez vous.
        </p>
      </div>
      <button
        onClick={onRefreshLocation}
        disabled={isLocating}
        className="flex items-center gap-2 px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-sm font-semibold hover:bg-gray-700 hover:text-amber-400 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <FiRefreshCw className={`w-4 h-4 ${isLocating ? 'animate-spin' : ''}`} />
        {isLocating ? 'Localisation...' : 'Actualiser ma position'}
      </button>
    </header>
  );
};

export default SearchHeader;





